const defaultState = {
  items: [],
  type: null,
  clients: [],
  hasMore: false,
  endBefore: null,
  startAfter: null,
  hasPrevious: false,
}


export default function list(state = defaultState, action) {
  switch (action.type) {
    case 'GET_LIST': return {
      ...action.data,
      hasMore: false,
      endBefore: null,
      startAfter: null,
      hasPrevious: false,
    }

    case 'GET_LIST_SUCCESS': return {
      ...action.data,
      ...(Array.isArray(action.items) ? { items: action.items } : action.items),
      type: action.listType,
    }

    case 'GET_CLIENTS_SUCCESS': return {
      clients: action.items,
    }

    default: return state
  }
}
